import * as R from "ramda";
import { EXPORTER_CLIENT } from "../common";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async createExport({ dispatch, rootGetters }, { entryId }) {
    await dispatch("auth/checkUserSession", {}, { root: true });
    const jwtToken = rootGetters["auth/getIdentityToken"];
    const Authorization = `Bearer ${jwtToken}`;

    const response = await EXPORTER_CLIENT.get(
      `/checklists/${entryId}`,
      {
        headers: { Authorization },
      }
    );

    // Array<{ contentType, url, extension }>
    const groupedExports = R.groupBy(
      (exprt) => exprt.extension || exprt.contentType,
      response.data
    );
    return groupedExports;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
